module.exports = __webpack_public_path__ + "img/custom-website-site-builder.02cc2691.jpg";